import { render, staticRenderFns } from "./CustomItemCreateEdit.vue?vue&type=template&id=5ed06a39&"
import script from "./CustomItemCreateEdit.vue?vue&type=script&lang=js&"
export * from "./CustomItemCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports